export const cardsForType: Record<string, string[]> = {
  all: [
    'sales_order_status',
    'credit_status',
    'tax_status',
    'invoice_status',
    'payment_status',
    'shipment_status',
    'moscow',
    'key_account_manager',
    'root_category',
    'created_at_interval',
    'is_sample',
  ],
  sale: [
    'sales_order_status',
    'tax_status',
    'invoice_status',
    'payment_status',
    'shipment_status',
    'moscow',
    'key_account_manager',
    'root_category',
    'created_at_interval',
    'is_sample',
  ],
  profile: [
    'sales_order_status',
    'tax_status',
    'moscow',
    'key_account_manager',
    'root_category',
    'created_at_interval',
    'is_sample',
  ],
  finance: [
    'sales_order_status',
    'invoice_status',
    'payment_status',
    'moscow',
    'key_account_manager',
    'root_category',
    'created_at_interval',
    'is_sample',
  ],
  logistic: [
    'sales_order_status',
    'shipment_status',
    'moscow',
    'delivery_option',
    'key_account_manager',
    'root_category',
    'created_at_interval',
    'is_sample',
  ],
  credit: [
    'sales_order_status',
    'credit_status',
    'key_account_manager',
    'created_at_interval',
    'credit_expected_payment_date_interval',
  ],
}
